/** Google Analytics switch per environment (`.env.*` locally, Vercel project settings in production/preview). */
export const analyticsEnabled = process.env.NEXT_PUBLIC_ANALYTICS_ENABLED === 'true';

/** GA4 measurement ID; only used when analytics is enabled (and still only after cookie consent). */
export const GA_MEASUREMENT_ID = analyticsEnabled ? (process.env.NEXT_PUBLIC_GA_MEASUREMENT_ID ?? '') : '';

/** Server-only mail settings (see .env and the per-environment .env files). */
export const mailConfig = {
  host: process.env.MAIL_SERVER_HOST ?? '',
  port: Number(process.env.MAIL_SERVER_PORT ?? 0),
  secure: (process.env.MAIL_SERVER_SECURE ?? 'true') === 'true',
  user: process.env.MAIL_SERVER_USER ?? '',
  password: process.env.MAIL_SERVER_PASSWORD ?? '',
  from: process.env.MAIL_FROM ?? '',
  /** Recipient of contact-form mails. Unset = the form refuses to send. */
  to: process.env.MAIL_TO || undefined,
  subjectPrefix: process.env.MAIL_SUBJECT_PREFIX ?? '',
};
